{
  "panel": {
    "title": "计划",
    "trackerTitle": "计划跟踪",
    "loading": "正在加载计划……",
    "empty": "尚无计划。",
    "emptyTitle": "尚无计划",
    "emptyHint": "上传任务说明以生成计划。",
    "loadFailed": "无法加载计划。"
  },
  "generation": {
    "starting": "正在启动计划生成……",
    "structure": "正在构建计划结构……",
    "enrichment": "正在丰富计划条目……",
    "stage": "第 {{stage}} / {{total}} 阶段",
    "itemsEnriched": "已丰富 {{enriched}} / {{total}} 项",
    "complete": "计划已生成。",
    "failed": "计划生成失败。",
    "errorContact": "计划生成失败，请重试。",
    "regenerate": "重新生成计划",
    "regenerating": "正在重新生成计划……",
    "abort": "中止",
    "aborting": "正在中止……"
  },
  "review": {
    "title": "审阅计划",
    "subtitle": "在生成报告之前，批准、编辑或对计划提出修改建议。",
    "approve": "批准计划",
    "approveAndGenerate": "批准并生成报告",
    "approving": "批准中……",
    "approveFailed": "无法批准计划。",
    "requestChanges": "请求修改",
    "feedbackTitle": "计划反馈",
    "feedbackPlaceholder": "描述需要对计划做出的更改。",
    "feedbackSubmit": "发送反馈",
    "feedbackSubmitting": "正在发送……",
    "feedbackEmpty": "请先描述您的修改建议。",
    "feedbackSent": "反馈已收到，正在更新计划……",
    "approveItem": "批准此项",
    "rejectItem": "拒绝此项",
    "approveAllItems": "全部批准",
    "rejectAllItems": "全部拒绝",
    "addItem": "添加项目",
    "deleteItem": "删除项目",
    "moveUp": "上移",
    "moveDown": "下移",
    "indent": "缩进",
    "outdent": "减少缩进"
  },
  "item": {
    "untitled": "未命名章节",
    "noDescription": "暂无描述。",
    "edit": "编辑",
    "save": "保存",
    "cancel": "取消",
    "saving": "正在保存……",
    "saveFailed": "无法保存更改。",
    "titleLabel": "标题",
    "descriptionLabel": "描述",
    "methodologyLabel": "方法论",
    "dataRequirementsLabel": "数据要求",
    "outputFormatLabel": "输出格式",
    "qualityCriteriaLabel": "质量标准",
    "expand": "展开",
    "collapse": "收起",
    "viewDetails": "查看详情",
    "rejected": "已拒绝",
    "approved": "已批准",
    "pending": "待审阅"
  },
  "actions": {
    "approveAndStartReport": "批准计划并开始生成报告",
    "abortAndRevise": "中止并修订",
    "duplicate": "复制"
  },
  "progress": {
    "buildingYourPlan": "正在构建您的计划",
    "inProgress": "计划生成进行中……",
    "stepPlanning": "正在生成计划结构",
    "stepEnriching": "正在丰富章节细节",
    "generatingStructure": "正在生成计划结构……",
    "analyzing": "分析中……",
    "finalizing": "正在敲定计划结构……",
    "enrichingDetails": "正在丰富章节细节……",
    "noPlan": "暂无可用计划",
    "feedbackApplied": "计划已根据您的反馈更新",
    "feedbackRefreshFailed": "反馈提交后计划刷新失败",
    "feedbackUpdateFailed": "计划更新失败"
  }
}
